module.exports = __webpack_public_path__ + "6d4f7772.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components_new/common/location-pin.svg
// module id = 2777
// module chunks = 15